export default "__VITE_ASSET__CfCHei4I__"